import { observer } from 'mobx-react';
import React from 'react';
import { getQuestionComponentRegistryEntry } from '../component-registry';
export default observer(function (_ref) {
  var vm = _ref.vm;
  var entry = getQuestionComponentRegistryEntry(vm === null || vm === void 0 ? void 0 : vm.type);
  var ValueComponent = entry ? entry.ValueComponent : undefined;
  return ValueComponent ? /*#__PURE__*/React.createElement(ValueComponent, {
    vm: vm
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, "N/A");
});
//# sourceMappingURL=index.js.map
